export default __webpack_public_path__ + "media/color/eos-fb40b8e0.svg";